module.exports = __webpack_public_path__ + "static/icons/icon-plus-f11e333a3cf827719bdd099a7c9762a8.svg";